export const DEFAULT_DAYS = 5;
export const COMPACT_DAYS = 6;

export const CARD_HEIGHT = 357;

export const tableClass =
    "dash-table transition-colors duration-150 " +
    "[&_.ant-table-thead>tr>th]:!border-none " +
    "[&_.ant-table-thead>tr>th]:!border-b-0 " +
    "[&_.ant-table-thead>tr>th::before]:hidden " +
    "[&_.ant-table-tbody>tr>td]:transition-colors " +
    "[&_.ant-table-tbody>tr>td]:!border-0 " +
    "[&_.ant-table-placeholder]:!border-0";

/**
 * Mini(5 rows)
 * 13px fontsize
 * 6px - vertical, 10px - horizontal
 */
export const tableDefault =
    "[&_.ant-table]:text-[13px] " +
    "[&_.ant-table-thead>tr>th]:py-[6px] [&_.ant-table-thead>tr>th]:px-[10px] [&_.ant-table-thead>tr>th]:leading-[1.25] " +
    "[&_.ant-table-tbody>tr>td]:py-[6px] [&_.ant-table-tbody>tr>td]:px-[10px] [&_.ant-table-tbody>tr>td]:leading-[1.25] " +
    "[&_.ant-table-tbody>tr>td_.ant-typography]:m-0";

/**
 * Compact(6 rows)
 * 12px fontsize
 * 4px - vertical, 10px - horizontal
 */
export const tableCompact =
    "[&_.ant-table]:text-[12px] " +
    "[&_.ant-table-thead>tr>th]:py-[4px] [&_.ant-table-thead>tr>th]:px-[10px] [&_.ant-table-thead>tr>th]:leading-[1.25] " +
    "[&_.ant-table-tbody>tr>td]:py-[4px] [&_.ant-table-tbody>tr>td]:px-[10px] [&_.ant-table-tbody>tr>td]:leading-[1.25] " +
    "[&_.ant-table-tbody>tr>td_.ant-typography]:m-0";
